module.exports = __webpack_public_path__ + "img/arrow-left-grey.7b395ec8.svg";